import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#5924B0',
      dark: '#471D8D',
      light: '#EEE9F7',
      contrastText: '#FFFFFF',
      hover: {
        main: '#50209E',
        light: '#E6DEF3',
      },
      active: {
        main: '#471D8D',
        light: '#CCBBE7',
      },
    },
    secondary: {
      main: '#3861A6',
    },
    grey: {
      25: '#FCFCFD',
      50: '#F9FAFB',
      100: '#F2F4F7',
      200: '#EAECF0',
      300: '#D0D5DD',
      400: '#98A2B3',
      500: '#667085',
      600: '#475467',
      700: '#344054',
      800: '#1D2939',
      900: '#101828',
    },
    error: {
      main: '#C64444',
      50: '#FFE9E9',
      100: '#FCBBBB',
      200: '#FA9999',
      300: '#F97777',
      400: '#F75555',
      500: '#C64444',
    },
    warning: {
      main: '#FFA51F',
      50: '#FEF5D0',
      100: '#FDEBA1',
      200: '#FCE073',
      300: '#FBD644',
      400: '#FFA51F',
      500: '#C8A311',
    },
    success: {
      main: '#27AE60',
      50: '#DDFFEB',
      100: '#A9DFBF',
      200: '#7DCEA0',
      300: '#52BE80',
      400: '#27AE60',
      500: '#27AE60',
    },
    background: {
      default: '#F9FAFB',
    },
    text: {
      primary: '#344054',
      secondary: '#667085',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      xmd: 1024,
      xmd2: 1060,
      xxmd: 1204,
      lg: 1279,
      lgX: 1420,
      xl: 1900,
      xxl: 2200,
      xxlg: 2500,
    },
  },
});
